module.exports = "/_next/static/images/header-clock-f9fe99025fb76d49cb4f33e4dbdddb2c.svg";